import React from 'react';
import Icon from '../../../components/AppIcon';

const NextStepsSection = ({ nextSteps, questionsForAgent }) => {
  return (
    <div className="w-full bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-elevation-sm">
      <div className="flex items-center gap-3 mb-6 md:mb-8">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="ListChecks" size={24} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
          Questions to Ask Agent &amp; Next Steps
        </h2>
      </div>
      <div className="space-y-6 md:space-y-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Icon name="MessageCircle" size={20} color="var(--color-accent)" />
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              Questions for the Agent
            </h3>
          </div>
          <div className="space-y-3">
            {questionsForAgent?.map((question, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-muted/50 hover:bg-muted transition-base"
              >
                <div className="flex-shrink-0 mt-1">
                  <div className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center">
                    <span className="text-xs font-semibold text-accent text-data">
                      {index + 1}
                    </span>
                  </div>
                </div>
                <p className="text-sm md:text-base text-foreground leading-relaxed font-body flex-1">
                  {question}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="h-px bg-border" />

        <div>
          <div className="flex items-center gap-2 mb-4">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            <h3 className="text-lg md:text-xl font-semibold text-foreground">
              Recommended Next Steps
            </h3>
          </div>
          <div className="space-y-3">
            {nextSteps?.map((step, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-primary/5 border border-primary/20 hover:bg-primary/10 transition-base"
              >
                <div className="flex-shrink-0 mt-1">
                  <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center">
                    <Icon name="ArrowRight" size={14} color="var(--color-primary)" />
                  </div>
                </div>
                <p className="text-sm md:text-base text-foreground leading-relaxed font-body flex-1">
                  {step}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="p-4 md:p-6 rounded-lg bg-success/5 border border-success/20">
          <div className="flex items-start gap-3">
            <Icon name="Target" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">
                Action Timeline
              </h3>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                Complete these steps within 7-10 days to maintain momentum. Properties in competitive markets can move quickly, so timely action on inspections and due diligence is crucial.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextStepsSection;